import React, { useEffect, useState } from "react";
import "../DoctorConsole.scss";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import RecordsPagination from "../Utils/RecordsPagination";
import { organizedArrayByHiTypes } from "../Utils/UtilsFunctions";
import Icon from "../Utils/Icons";

const AbdmRecords = ({ organizedArray }) => {
  console.log("Data from Abdm Records Page", organizedArray);
  const [abdmFhir, setAbdmFhir] = useState(null);

  useEffect(() => {
    if (organizedArray !== null) {
      const copiedArray = JSON.parse(JSON.stringify(organizedArray));
      const modifiedFhirArray = organizedArrayByHiTypes(copiedArray);
      setAbdmFhir(modifiedFhirArray);
    }
  }, [organizedArray]);
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const formatDate = (visitDatetime) => {
    const formattedDate = new Date(visitDatetime);

    const day = String(formattedDate.getDate()).padStart(2, "0");
    const month = String(formattedDate.getMonth() + 1).padStart(2, "0"); // January is 0!
    const year = String(formattedDate.getFullYear()).slice(-2); // Extract the last two digits of the year

    let hours = formattedDate.getHours();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // Handle midnight
    const minutes = String(formattedDate.getMinutes()).padStart(2, "0");

    const formattedDateTime = `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;

    console.log(formattedDateTime);
    return formattedDateTime;
  };
  const formatDateComposition = (inputDate) => {
    const date = new Date(inputDate);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    function getOrdinalSuffix(n) {
      if (n >= 11 && n <= 13) {
        return "th";
      }
      switch (n % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    }

    const formattedDate = `${day}${getOrdinalSuffix(day)} ${month}, ${year}`;
    return formattedDate;
  };

  return (
    <>
      {abdmFhir !== null && abdmFhir.length > 0 ? (
        abdmFhir.map((visit, index) => {
          // Flatten records
          const flattenedRecords = visit["fhir_data"].flatMap((dateObject) =>
            Object.entries(dateObject).flatMap(([date, items]) =>
              items.flatMap((item) =>
                Object.entries(item).map(([sectionName, sectionData]) => ({
                  sectionName,
                  sectionData,
                }))
              )
            )
          );
          console.log("Flattened Records", flattenedRecords);

          return (
            <Accordion key={index} className="outer-accordion" defaultExpanded>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`visit-${index}-content`}
                id={`visit-${index}-header`}
                className="outer-accordion-summary"
              >
                <Typography className="accordion-section-title">
                  {visit.hipId}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                {flattenedRecords.length > 0 ? (
                  <RecordsPagination records={flattenedRecords} />
                ) : (
                  "There is some issue in data"
                )}
              </AccordionDetails>
            </Accordion>
          );
        })
      ) : (
        // <Typography>No Abdm Records found</Typography>
        <div
          style={{
            justifyContent: "center",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Icon name="noRecordsFound" size={80} />
        </div>
      )}
    </>
  );
};

export default AbdmRecords;
